<!--
 * @Author: Linpengze
 * @Date: 2022-06-08 14:57:24
 * @LAstEditors: Linpengze
 * @LastEditTime: 2022-06-08 14:57:24
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\systemManagement\CSDocumentManagement\accessConfig\index.vue
-->
<template>
    <div class="app-container">
        <el-card class="filter-container" shadow="never">
            <el-form
                    :model="listQuery"
                    size="medium"
                    :inline="true"
            >
                <el-row>
                    <el-col :span="19">
                        <el-input
                                v-model="listQuery.keyWord"
                                placeholder="输入关键词搜索，支持:昵称 / 姓氏 / 名字 / 手机号"
                                size="medium"
                                clearable
                                @keyup.native.enter="onChangeProperty"
                        ><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
                    </el-col>
                    <el-col :span="5">
                        <el-button type="primary" size="medium" style="margin-left: 5px;border-radius: 2px" @click="onChangeProperty">
                            {{ $t("search") }}
                        </el-button>
                        <el-button
                                type="primary"
                                size="medium"
                                title="Add File"
                                style="border-radius: 2px;margin-top: 2px;margin-left: 5px"
                                @click="openAddDialog"
                        >新增用户
                        </el-button>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 20px">
                    <el-col :span="20">
                        <el-select
                                size="medium"
                                v-model="listQuery.roleID"
                                placeholder="全部角色"
                                clearable
                                @change="onChangeProperty"
                        >
                            <el-option
                                    v-for="item in roleList"
                                    :key="item.roleID"
                                    :label="item.roleName"
                                    :value="item.roleID"
                            ></el-option
                            >
                        </el-select>
                        <el-select
                                size="medium"
                                v-model="listQuery.conditionID"
                                placeholder="全部分类"
                                style="margin-left: 3px;margin-top: 3px"
                                clearable
                                @change="onChangeProperty"
                        >
                            <el-option
                                    v-for="item in categoryList"
                                    :key="item.csFileConditionID"
                                    :label="item.showName"
                                    :value="item.csFileConditionID"
                            ></el-option
                            >
                        </el-select>
                    </el-col>
                </el-row>
            </el-form>
        </el-card>
        <div class="main">
            <el-table
                    v-loading="loading"
                    :data="dataList"
                    :header-cell-style="{ background: '#F5F7FA' }"
                    style="width: 100%; margin-bottom: 20px"
                    stripe
                    border
            >
                <el-table-column prop="userID" label="用户ID" align="center" width="100">
                </el-table-column>
                <el-table-column prop="nickname" label="昵称" align="center" width="150" show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="真实姓名" align="center" width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.fullName===null?"-":scope.row.fullName}}
                    </template>
                </el-table-column>
                <el-table-column prop="mobilePhone" label="手机号" align="center" width="150">
                </el-table-column>
                <el-table-column label="资料访问角色" align="center" width="150">
                    <template slot-scope="scope">
                        <a style="color: blue">
                            {{ scope.row.roleName}}
                        </a>
                    </template>
                </el-table-column>
                <el-table-column prop="seriesIDList" label="设备集合" align="center">
                    <template slot-scope="scope">
                        <el-tag
                                style="margin-right: 10px;margin-top: 5px"
                                v-for="(item,index) in scope.row.seriesList"
                                :key="item.machineSeriesID"
                                v-show="index < numFlag"
                                type="primary"
                                size="small"
                        >{{ item.model }}{{" "+item.version}}</el-tag>
                        <el-tag v-if="scope.row.seriesList.length > numFlag+1">
                            +{{scope.row.seriesList.length - numFlag +1}}
                        </el-tag>
                        <el-tag
                                v-if="scope.row.all===1"
                                style="margin-right: 10px;margin-top: 5px"
                                type="info"
                                size="small"
                        >{{"所有设备"}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column  label="操作:编辑 / 删除" align="center" width="200">
                    <template slot-scope="scope">
                      <el-button
                          size="medium"
                          title="Agree user"
                          icon="el-icon-edit"
                          @click="openEditDialog(scope.row)"
                      >
                      </el-button>
                      <el-button
                          type="danger"
                          size="medium"
                          title="Disagree user"
                          icon="el-icon-delete"
                          @click="deleteRow(scope.row)"
                      >
                      </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div v-show="totalCount > pageSize" class="pagination">
            <el-pagination
                    v-show="dataList.length > 0"
                    background
                    layout="prev, pager, next"
                    :page-size="pageSize"
                    :total="totalCount"
                    :current-page="currentPage"
                    @current-change="currentChange"
            />
        </div>
        <p style="color: dimgrey">共{{totalCount}}条</p>

        <!-- 添加用户角色 -->
        <el-dialog title="绑定用户与资料访问角色" :visible.sync="addDialog" width="60%">
            <div style="overflow-y: auto; height: 500px">
                <el-form :model="addForm">
                    <el-form-item label="选择用户" label-width="125px" required>
                        <el-autocomplete
                                popper-class="my-autocomplete"
                                style="width: 90%"
                                clearable
                                v-model="addForm.name"
                                :trigger-on-focus="false"
                                :debounce="10"
                                :fetch-suggestions="querySearchAsync"
                                placeholder="输入关键字：用户名/ID/姓名/手机号/邮箱/单位，并用空格键激活搜索"
                                @select="handleSelect"
                                @keyup.enter.native="handleSubmit"
                        >
                            <template slot-scope="{ item }" style="width: 90%">
                                <div class="name">{{ item.value }}</div>
                                <span class="addr">{{ item.addr }}</span>
                            </template>
                        </el-autocomplete>
                        <el-button type="primary" style="margin-top: 5px;margin-left: 2px" @click="inspectUser()">检测用户</el-button> {{userDesc}}
                    </el-form-item>
                    <el-form-item label="分配角色" label-width="125px">
                        <el-select v-model="addForm.roleList[0].roleId" style="width: 90%"  @change="handleChangeRole($event,1)">
                            <el-option
                                    :label="item.roleName"
                                    :value="item.roleID"
                                    v-for="item of roleList"
                                    :key="item.roleID"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="授权设备" label-width="125px" v-if="showAddDevice">
                        <p style="margin-top: 5px;line-height:2em;color: gray" ><i class="el-icon-warning-outline" style="color: red"></i>可多选。配置后，用户只能访问与授权设备相关的文档资料</p>
                        <el-radio-group v-model="all" @change="changeAllFlag()">
                            <el-radio  label="0">绑定个别设备</el-radio>
                            <el-radio  label="1">绑定所有设备(包括后期新增)</el-radio>
                        </el-radio-group>
    <!--                    <el-select style="width: 90%;margin-top: 5px" :disabled="allFlagJudge" v-model="addForm.roleList[0].seriesIdList" multiple collapse-tags filterable remote reserve-keyword-->
    <!--                               placeholder="搜索关键词或列表多选" :remote-method="(queryString)=>-->
    <!--                       {remoteMethod(queryString, seriesData);}">-->
    <!--                        <el-checkbox-->
    <!--                                v-model="check1"-->
    <!--                                :indeterminate="addForm.roleList[0].seriesIdList.length !== seriesData.length"-->
    <!--                                @change="selectAll1"-->
    <!--                        >-->
    <!--                            全选-->
    <!--                        </el-checkbox>-->
    <!--                        <el-option v-for="item in seriesData"-->
    <!--                                   :key="item.key"-->
    <!--                                   :label="item.label"-->
    <!--                                   :value="item.key">-->
    <!--                        </el-option>-->
    <!--                    </el-select>-->
                        <el-transfer
                                filterable
                                v-if="!allFlagJudge"
                                :disabled="allFlagJudge"
                                :filter-method="filterMethod"
                                filter-placeholder="请输入设备关键字"
                                v-model="addForm.roleList[0].seriesIdList"
                                :titles="['可选设备', '已选设备']"
                                :data="seriesData">
                        </el-transfer>
                    </el-form-item>
                    <el-form-item label-width="125px">{{accessDesc}}</el-form-item>
                    <el-form-item label-width="125px" label="角色权限">
                        <el-table
                                :data="roleAccessData"
                                style="width: 90%"
                                max-height="200px"
                        >
                            <el-table-column
                                    prop="typeName"
                                    label="资料类型"
                                    >
                            </el-table-column>
                            <el-table-column
                                    prop="read"
                                    label="读权限"
                                    >
                            </el-table-column>
                            <el-table-column
                                    prop="download"
                                    label="下载权限">
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer">
                <el-button size="small" @click="addDialog = false">
                    取消
                </el-button>
                <el-button type="primary" size="small" @click="addUser()">
                    确认
                </el-button>
            </div>
        </el-dialog>

        <el-dialog title="编辑用户“资料访问角色”与“设备”" :visible.sync="editDialog" width="60%">
            <div style="overflow-y: auto; height: 520px">
                <el-form :model="editForm">
                    <el-form-item label="当前用户" label-width="125px" required>
                        {{editForm.name}}
                    </el-form-item>
                    <el-form-item label="分配角色" label-width="125px">
                        <el-select v-model="editForm.roleList[0].roleId" style="width: 90%"  @change="handleChangeRole($event,2)">
                            <el-option
                                    :label="item.roleName"
                                    :value="item.roleID"
                                    v-for="item of roleList"
                                    :key="item.roleID"
                            >
                            </el-option>
                        </el-select>
                        <p>{{accessDesc}}</p>
                    </el-form-item>
                    <el-form-item label="授权设备" label-width="125px" v-if="showAddDevice">
                        <p style="margin-top: 5px;line-height:2em;color: gray" ><i class="el-icon-warning-outline" style="color: red"></i>可多选。配置后，用户只能访问与授权设备相关的文档资料</p>
                        <el-radio-group v-model="all" @change="changeAllFlag()">
                            <el-radio  label="0">绑定个别设备</el-radio>
                            <el-radio  label="1">绑定所有设备(包括后期新增)</el-radio>
                        </el-radio-group>
                        <el-transfer
                                v-if="!allFlagJudge"
                                :disabled="allFlagJudge"
                                filterable
                                @change="forceUpdate"
                                :filter-method="filterMethod"
                                filter-placeholder="请输入设备关键字"
                                v-model="editForm.roleList[0].seriesIdList"
                                :titles="['可选设备', '已选设备']"
                                :data="seriesData">
                        </el-transfer>
                    </el-form-item>
                    <el-form-item label-width="125px" label="角色权限">
                        <el-table
                                :data="roleAccessData"
                                style="width: 90%"
                                max-height="200px"
                        >
                            <el-table-column
                                    prop="typeName"
                                    label="资料类型"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="read"
                                    label="读权限"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="download"
                                    label="下载权限">
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer">
                <el-button size="small" @click="editDialog = false">
                    取消
                </el-button>
                <el-button type="primary" size="small" @click="editUser()">
                    确认
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    getSeriesList,
    getCsRoleList,
} from "@/api/system/CSDocument/file";

import {
    getCsRoleUserList,
    bindUserRoleDevice,
    unbindUserRoleDevice,
    getUserInfo,
    inspectUser,
    getCsFileAccess
} from "@/api/system/CSDocument/user";
import {
    getAllUserList
} from "@/api/userManagement";
import {userBindRole} from "../../../../api/role";

export default {
    data() {
        return {
            numFlag:4,
            loading:false,
            roleAccessData:[],
            disPlayAuto:false,
            userDesc:"",
            accessDesc:" ",
            totalCount: 0, // 总数
            currentPage: 1, // 当前页码
            pageSize: 10, // 每页条数
            addDialog:false,
            editDialog:false,
            showAddDevice:true,
            editForm:{
                name:'',
                userId:'',
                roleList:[{roleId:'',seriesIdList:[]}],
            },
            addForm:{
                name:'',
                userId:'',
                all:'',
                roleList:[{roleId:'',seriesIdList:[]}],
            },
            deleteForm:{
                userId:'',
                roleId:'',
            },
            listQuery:{
                keyWord:"",
                roleID:'',
                conditionID:'',
            },
            categoryList:[{csFileConditionID:0,showName:"超声"},{csFileConditionID:1,showName:"DR"},{csFileConditionID:2,showName:"全部"}],  //分类列表
            seriesData:[],    //设备列表
            roleList:[],
            dataList:[],
            searchList:[],
            beforeKeyWord:"",
            results:[],
            all: '0',
            allFlagJudge: false,
        }
    },
    created() {
        this.getSeriesList();         //获取适用机型列表
        this.getCsRoleList();
        this.listQuery.conditionID=2;
        this.getDataList();
    },
    computed: {
        check1: {
            get () {
                if (this.addForm.roleList[0].seriesIdList.length === this.seriesData.length) {
                    return true
                }
                return false
            },
            set () {}
        },
        check2: {
            get () {
                if (this.editForm.roleList[0].seriesIdList.length === this.seriesData.length) {
                    return true
                }
                return false
            },
            set () {}
        }
    },
    methods: {
        forceUpdate(){
            this.$forceUpdate()
        },
        filterMethod(query, item) {
            return item.label.indexOf(query) > -1;
        },

        onChangeProperty(){
            this.currentPage=1; // 当前页码
            this.pageSize=10; // 每页条数
            this.getDataList();
        },

        selectAll1 (checked) {
            if (checked) {
                this.addForm.roleList[0].seriesIdList = this.seriesData.map(d => d.key)
            } else {
                this.addForm.roleList[0].seriesIdList = []
            }
        },
        selectAll2 (checked) {
            if (checked) {
                this.editForm.roleList[0].seriesIdList = this.seriesData.map(d => d.key)
            } else {
                this.editForm.roleList[0].seriesIdList = []
            }
        },

        changeAllFlag() {
            if (this.all === '1') {
                this.allFlagJudge = true;
                this.addForm.roleList[0].seriesIdList=[];
                this.editForm.roleList[0].seriesIdList=[];
            } else {
                this.allFlagJudge = false;
            }
        },

        handleSubmit() {
            this.changeStyle("none", ".el-autocomplete-suggestion");
        },

        //根据传进来的状态改变建议输入框的状态（展开|隐藏）
        changeStyle(status, className) {
            let dom = document.querySelectorAll(className);
            dom[0].style.display = status;
        },

        /**
         * 按钮重置
         */
        reset(){
             this.listQuery.keyWord="";
             this.listQuery.roleID='';
             this.listQuery.conditionID='';
             this.getDataList();
        },

        /**
         * 解绑用户与文档访问角色
         */
        deleteRow(e){
            console.log(e);
            if(e!==null){
                let params={
                    roleId:e.roleID,
                    userId:e.userID
                };
                let tips = "您确定要解除此用户和资料访问角色的绑定吗？";
                this.$confirm(tips, this.$t("tips"), {
                    confirmButtonText: this.$t("yes"),
                    cancelButtonText: this.$t("no"),
                    type: "warning",
                })
                    .then(() => {
                        unbindUserRoleDevice(params).then((res)=>{
                            if(res.code===200){
                                this.$notify({
                                    title: '删除成功',
                                    message: '已解除该用户的资料访问角色',
                                    type: 'success'
                                });
                                this.getDataList();
                            }
                        });
                    });
            }
        },

        /**
         * 对话框 修改角色，决定是否展示设备信息栏
         */
        handleChangeRole(e,flag){
            this.all='0';
            this.addForm.roleList[0].seriesIdList=[];
            this.editForm.roleList[0].seriesIdList=[];
            this.changeAllFlag();
            if(e!=null && this.roleList!==[]){
                for(const temp of this.roleList){
                    if(temp.roleID===e){
                        if(temp.priorityInCs===1){
                            this.showAddDevice=true;
                            this.accessDesc=""
                        }
                        else if(temp.priorityInCs===3){
                            this.showAddDevice=false;
                            this.accessDesc="温馨提示：此角色允许访问所有文件"
                        }
                        else if(temp.priorityInCs===2){
                            this.showAddDevice=false;
                            this.accessDesc="温馨提示：此角色:1.可访问“资料类型”中为此角色配置权限的文件；2.可访问普通用户能访问的文件"
                        }
                        else if(temp.priorityInCs===0){
                            this.showAddDevice=false;
                            this.accessDesc="温馨提示：此角色允许访问普通用户能访问的文件；此角色不在列表中展示"
                        }

                    }
                }
            }
            else{
                this.showAddDevice=true;
                this.accessDesc=" ";
            }
            this.showFileTypeAccess(e);
        },

        showFileTypeAccess(e){
            if(e!==null){
                this.roleAccessData=[];
                getCsFileAccess(e).then((res)=>{
                    console.log(e);
                    if(res.code===200 && res.data!==[]){
                        for(const temp of res.data){
                            const temp1={};
                            temp1.typeName=temp.typeName;
                            if(1 === temp.permissionType){
                                temp1.read = "√";
                                temp1.download="×";
                                this.roleAccessData.push(temp1);
                            }
                            else if(2 === temp.permissionType){
                                temp1.read = "√";
                                temp1.download="√";
                                this.roleAccessData.push(temp1);
                            }
                        }
                    }
                })
            }
        },

        /**
         * 列表搜索
         */
        getDataList(){
            this.dataList=[];
            const params={
                pageNumber:this.currentPage,
                pageSize:this.pageSize,
                // sortOrder:"asc",
            };
            if(this.listQuery.keyWord!==""){
                params.keyWord=this.listQuery.keyWord;
            }
            if(this.listQuery.conditionID!==""){
                params.userDataType=this.listQuery.conditionID;
            }
            else{
                params.userDataType=2;
            }
            if(this.listQuery.roleID !== ""){
                params.where=[];
                if (this.listQuery.roleID !== "") {
                    params.where.push({"field":"roleID","value":this.listQuery.roleID.toString(),"op":"equal"});
                }
            }
            this.loading = true;
            getCsRoleUserList(params).then((res)=>{
                if (res.code === 200) {
                    if (res.data.rows !== []) {
                        for (const temp of res.data.rows) {
                            if (temp.seriesList!==[] && temp.seriesList[0] === null) {
                                temp.seriesList = [];
                            }
                            this.dataList.push(temp);
                        }
                    }
                    this.totalCount=res.data.total;
                }
                this.loading=false;
            });
        },

        /**
         * 获取所有用户列表
         */
        getAllUserList(keyWord) {
            const params = {
                sortName: "",
                sortOrder: "",
                pageNumber: 1,
                pageSize: 100,
                keyWord: keyWord,
            };
            getAllUserList(params).then((res) => {
                this.searchList=res.data.rows;
            });
        },

        /**
         * 打开新增对话框
         */
        openAddDialog(){
            this.addDialog=true;
            this.showAddDevice=true;
            this.accessDesc=" ";
            this.addForm.userId='';
            this.addForm.name='';
            this.all='0';
            this.changeAllFlag();
            this.userDesc="";
            this.roleAccessData=[];
            this.addForm.roleList=[{roleId:'',seriesIdList:[]}];

        },
        /**
         * 打开编辑对话框
         */
        openEditDialog(e){
            this.editDialog=true;
            this.showAddDevice=true;
            this.editForm.name=e.nickname;
            this.editForm.userId=e.userID;
            this.editForm.roleList[0].roleId=e.roleID;
            this.handleChangeRole(e.roleID,2);
            if (e.all === null || e.all === 0) {
                this.all='0';
            }
            else{
                this.all='1';
            }
            this.changeAllFlag();
            this.editForm.roleList[0].seriesIdList=[];
            if(e.seriesList!==[]){
                for(const temp of e.seriesList){
                    this.editForm.roleList[0].seriesIdList.push(temp.machineSeriesID);
                }
            }
        },

        /**
         * 新增记录 用户与角色绑定
         */
        addUser(){
            if(this.addForm.userId===""){
                this.$message({
                    message: "请填写用户信息,点击“检测用户”按钮,若提示“已关联用户+用户信息”则填写成功",
                    type: "warning",
                });
                return;
            }
            if(this.addForm.roleList[0].roleId===''){
                this.$message({
                    message: "资料访问角色不能为空",
                    type: "warning",
                });
                return;
            }
            const allFlag=this.all==='0'?0:1;
            let params = {
                userId: this.addForm.userId,
                roleList: [{
                    roleId: this.addForm.roleList[0].roleId,
                    all: allFlag,
                    seriesIdList: this.addForm.roleList[0].seriesIdList
                }]
            };
            bindUserRoleDevice(params).then((res)=>{
                if(res.data===200){
                    this.$message({
                        message: "绑定成功",
                        type: "success",
                    });
                }

                this.addForm.userId='';
                this.addForm.name="";
                this.addForm.roleList[0]={roleId:'',seriesIdList:[]};
                this.addDialog=false;
                this.getDataList();
            });
        },

        /**
         * 编辑
         */
        editUser(){
            if(this.editForm.userId!==""){
                if(this.editForm.roleList[0].roleId===''){
                    this.$notify({
                        title: '操作成功',
                        message: '用户已绑定资料访问角色，请在列表中查阅',
                        type: 'success'
                    });
                    return;
                }
                const allFlag=this.all==='0'?0:1;
                let params={
                    userId:this.editForm.userId,
                    roleList: [{
                        roleId: this.editForm.roleList[0].roleId,
                        all: allFlag,
                        seriesIdList: this.editForm.roleList[0].seriesIdList
                    }]
                };
                bindUserRoleDevice(params).then((res)=>{
                    if(res.data===200){
                        this.$message({
                            message: "绑定成功",
                            type: "success",
                        });
                    }
                    this.$notify({
                        title: '操作成功',
                        message: '已经为用户改绑资料访问角色',
                        type: 'success'
                    });
                    this.editForm.userId='';
                    this.editForm.name="";
                    this.editForm.roleList[0]={roleId:'',seriesIdList:[]};
                    this.editDialog=false;
                    this.getDataList();
                });

            }
        },

        /**
         * 翻页
         *
         * @param {number} currentPage 当前页码
         */
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.getDataList();
        },

        /**
         * 实时搜索用户信息
         */
        querySearchAsync(queryString, cb) {
            const results=[];
            if(queryString!==""){
                this.getAllUserList(queryString);
                if(this.searchList!==[]){
                    let addr="";
                    for(const temp of this.searchList){
                        addr="ID："+temp.userID;
                        if(temp.fullName!==""&& temp.fullName!==null){
                            addr+=" 姓名："+temp.fullName;
                        }
                        if(temp.mobilePhone!==null && temp.mobilePhone!==""){
                            addr+=" 手机："+temp.mobilePhone;
                        }
                        if(temp.organization!==null && temp.organization!==""){
                            addr+=" 单位："+temp.organization
                        }
                        results.push({value:temp.nickname,addr:addr,id:temp.userID});
                    }
                }
            }
            cb(results);
        },

        handleSelect(item) {
            console.log(item);
            this.addForm.userId=item.id;
            this.userDesc="已关联用户："+item.addr;
        },

        inspectUser(){
            this.userDesc="";
            if(this.addForm.name!==""){
                const param={
                    account:this.addForm.name
                };
                console.log(param);
                inspectUser(this.addForm.name).then((res)=>{
                    if(res.code===200){
                        if(res.data.status===0){
                            this.userDesc="用户不存在,请重新输入：手机号/Id/登录名/邮箱";
                        }
                        else if(res.data.status===1){
                            this.userDesc="用户被停用";
                        }
                        else if(res.data.status===3){
                            this.userDesc="未知错误,请联系系统管理员";
                        }
                        else if(res.data.status===2){
                            if(res.data.user!==null){
                                const temp=res.data.user
                                this.userDesc="已关联用户：ID：";
                                this.userDesc+=temp.userID;
                                this.addForm.userId=temp.userID;
                                if(temp.fullName!==null && temp.fullName!==""){
                                    this.userDesc+=" 姓名："+temp.fullName;
                                }
                                if(temp.loginName!==null && temp.loginName!==""){
                                    this.userDesc+=" 登陆名："+temp.loginName;
                                }
                                if(temp.mobilePhone!==null && temp.mobilePhone!==""){
                                    this.userDesc+=" 手机："+temp.mobilePhone;
                                }
                                if(temp.loginEmail!==null && temp.loginEmail!==""){
                                    this.userDesc+=" 邮箱："+temp.loginEmail;
                                }

                            }
                            else{
                                this.userDesc="找不到用户信息,请联系系统管理员";
                            }
                        }
                    }
                });
            }
        },

        /**
         * 获取用户信息
         */
        getUserInfo() {
            if (!this.addUserForm.name) {
                this.$message({
                    message: "名称不能为空。",
                    type: "warning",
                });
                return;
            }

            let params = {
                account: this.addUserForm.name,
            };
            getUserInfo(params).then((res) => {
                let status = res.resultData.status;
                switch (status) {
                    case 0:
                        this.$message({
                            message: "该用户不存在。",
                            type: "warning",
                        });
                        break;
                    case 2:
                        this.$message({
                            message: "This user exist.",
                            type: "success",
                        });
                        this.nickname = res.resultData.user.Nickname;
                        this.addUserForm.userID = res.resultData.user.UserID;
                        this.isUserExist = true;
                        break;
                }
            });
        },

        /**
         * 获取客服角色列表
         */
        getCsRoleList(){
            let param={
                orderType: "",
                orderBy: "",
                pageNo:1,
                pageSize:100,
            };
            getCsRoleList(param).then((res)=>{
                this.roleList=[];
                console.log(res);
                if (res.data !== null && res.data.result !== []) {
                    for (const temp of res.data.result) {
                        if(temp.priorityInCs!==null &&temp.priorityInCs!==0){
                            this.roleList.push(temp);
                        }
                    }
                }
            });
        },

        /**
         * 获取设备系列机型列表
         */
        getSeriesList() {
            return new Promise((resolve, reject) => {
                const param = {
                    sortName: "",
                    sortOrder: "asc",
                    pageNumber: 1,
                    pageSize: 500,
                    keyword: "",
                    where: "",
                };
                getSeriesList(param).then((res) => {
                    this.seriesData = [];
                    res.data.rows.forEach((i) => {
                        let obj = {
                            key: i.machineSeriesID,
                            label: i.model + " " + i.version,
                        };
                        this.seriesData.push(obj);
                    });
                    resolve("getSeriesList done");
                });
            });
        },

        /**
         * 根据关键字过滤设备信息
         */
        //重置options(select自动补全相关)
        remoteMethod(queryString, lists) {
            if(queryString !=="" && lists !== null){
                this.seriesData = [];
                for(var item of lists){
                    console.log(item);
                    if (item.label.lastIndexOf(queryString)!==-1){
                        this.seriesData.push(item);
                    }
                }
            }
            else{
                this.getSeriesList();
            }
        },

        updateSeries(){
          this.$forceUpdate();
        },
    }
};
</script>

<style lang="scss" scoped>

.my-autocomplete {
    li {
        line-height: normal;
        padding: 7px;
        .name {
            text-overflow: ellipsis;
            overflow: hidden;
        }
        .addr {
            font-size: 12px;
            color: #b4b4b4;
        }
        .highlighted .addr {
            color: #ddd;
        }
    }
}
.el-select__tags-text {
    display: inline-block;
    max-width: 200px;
    @media (max-width: 1400px) {
        max-width: 42px;
    }
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.el-select .el-tag__close.el-icon-close {
    top: -7px;
    right: -4px;
}

::v-deep .el-transfer {
    display: flex;
    align-items: center;
    .el-transfer-panel {
        width:240px;
    }
    .el-transfer__buttons {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .el-button.el-button--primary{
            margin-left: 0px;
        }
    }
}
</style>